// Подсказка в пустом поле: живая, но уместная на демо, которое смотрит заказчик.
const phrases = [
    "Начните писать текст...",
    "Пиши свои идеи, герой!",
    "Не жди музу — зови её текстом!",
    "Курсор мигает, как будто подмигивает — начни писать",
    "Клавиатура грустит без твоих гениальных мыслей",
    "Пусто? Ну так залей контентом!",
    "Одна строчка — уже начало романа",
    "Тут должен был быть текст. Напиши его сам",
    "Идея в голове? Вытащи её наружу!",
    "Ничего не приходит в голову? Начни писать — и оно придёт",
    "Твой текст может изменить мир... или хотя бы этот блок",
    "Думать — хорошо, писать — ещё лучше",
    "Ты знаешь, что хочешь написать. Просто начни",
    "Каждое великое произведение начиналось с пустого поля",
    "Стартуй. Даже если не знаешь куда",
    "Никакого давления... кроме мигающего курсора",
    "Вдохни, выдохни, напиши!",
    "Текст ждёт. А ты чего ждёшь?",
    "Мир без твоих слов скучен. Исправь это!",
    "Не строй башню в голове — строй мысли здесь.",
    "Слова — это твои блоки. Построй что-нибудь эпичное!",
];

export const getRandomPhrase = (): string => {
    const index = Math.floor(Math.random() * phrases.length);
    return phrases[index];
};
